import React, { Component } from 'react';

export default class ImpressumMainComponent extends Component {

    componentDidMount(){
        window.scrollTo(0, 0);
    }

    render(){
        return (
            <h1>Impressum</h1>
        )
    }

}